const ROUTES = {
  logout: "/logout"
};
const ACCESS_TYPE = {
  ALLUSER: "ALLUSER"
};
const IN_PROGRESS_URL = "/in-progress";
const NO_PHOTO_VALUE = "NA";
const ENT_GOV_ACCOUNT = "ent and govt";
const DC_FEATURE_CODES = ["MONITOR-RPT", "VISIT-MGT", "DELIVERY-MGT"];
const ESHOP_ACCESSIBLE_SEGMENTS = ["carrier sales", "ent and govt - eag", "ent and govt - govt", "global business - gb", "sgo"];
export { ACCESS_TYPE, DC_FEATURE_CODES, ENT_GOV_ACCOUNT, ESHOP_ACCESSIBLE_SEGMENTS, IN_PROGRESS_URL, NO_PHOTO_VALUE, ROUTES };